import {Box} from '@mui/material';

const ErrorContainer = ({error}) => (
  <Box
    sx={{
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
    {JSON.stringify(error)}
  </Box>
);

export default ErrorContainer;
